import { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import * as apiClient from "../api-client";
import Loader from "../components/LoaderComponent";
import { HelmetProvider } from "react-helmet-async";
import { Helmet } from "react-helmet";

const tagOptions = [
  { label: 'All', value: 'all' },
  { label: 'Beach Vibes', value: 'beach_vibes' },
  { label: 'Adventure', value: 'adventure' },
  { label: 'Love and Travel', value: 'love_and_travel' },
  { label: 'All Inclusive', value: 'all_inclusive' },
  { label: 'Family Compass', value: 'family_compass' },
];

const Blogs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const { data: blogs, isLoading } = useQuery('fetchBlogs', apiClient.fetchBlogs);
  const [selectedTag, setSelectedTag] = useState('all');

  if (isLoading) {
    return <Loader />;
  }

  const filteredBlogs = selectedTag === 'all' 
    ? blogs 
    : blogs?.filter(blog => blog.tags.includes(selectedTag));

  return (
    <>
    <HelmetProvider>
        <Helmet>
          <title>Travel Blog | Inspiration & Tips | Halo Holidays</title>
          <meta name="description" content="Discover travel inspiration, expert tips, and destination guides on our blog. Explore the world with Halo Holidays!" />
        </Helmet>
    </HelmetProvider>

    <div className="container mx-auto px-4 py-12">
      <h1 className="text-2xl font-semibold text-center">Your Essential Travel Guide & Inspiration</h1>
      <p className="text-lg mb-8 text-center">Unleash your wanderlust! Explore, discover, be inspired</p>
      
      <div className="flex justify-center flex-wrap gap-2 mb-8">
        {tagOptions.map(tag => (
          <button
            key={tag.value}
            onClick={() => setSelectedTag(tag.value)}
            className={`px-4 py-2 rounded text-sm font-medium ${selectedTag === tag.value ? 'bg-halo-pink text-white' : 'bg-gray-100 text-gray-700 hover:text-halo-pink'}`}
          >
            {tag.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {filteredBlogs?.slice().reverse().map(blog => (
          <div key={blog._id} className="border border-gray-300 p-4 rounded-lg">
            <Link to={`/blogs/${blog.slug}`}>
              {blog.imageUrls && blog.imageUrls.length > 0 && (
                <div className="">
                  <img src={blog.imageUrls[0]} alt={blog.title} className="rounded-lg w-full" />
                </div>
              )}
              <h2 className="text-lg font-semibold mt-2">{blog.title}</h2>
              <p className="mt-2">{blog.content.slice(0, 90)}...</p>
              <p className="mt-2 text-gray-500 text-sm">{new Date(blog.createdAt).toLocaleDateString()}</p>
            </Link>
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default Blogs;
